import { createSelector } from 'reselect'

export const selectRouting = (state) => state.routing

export const selectLocation = createSelector(
  selectRouting,
  (routing) => routing && routing.location,
)

export const selectPathname = createSelector(
  selectLocation,
  (location) => location && location.pathname,
)

export const selectQuery = createSelector(
  selectLocation,
  (location) => location && location.query,
)



// WEBPACK FOOTER //
// ./src/services/routing/selectors.js